// extracted by mini-css-extract-plugin
module.exports = {"avatarWrapper":"users_avatarWrapper__2Vnjg","removeIcon":"users_removeIcon__3ExvW","avatar":"users_avatar__xAek6","imgUploadWrapper":"users_imgUploadWrapper__nhIn0"};